export default "/images/x.svg?6c9a4ba71a333be7b021fc6da39d864c";